<template>
  <div style="background-color: white;padding-top:0.88rem;">
    <div class="news-nav" id="news-nav">
      <div class="news-nav-pre cus-pointer" @click="jump('/')">
        首页
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-pre cus-pointer" @click="jump('/product')">
        产品中心
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-pre cus-pointer" @click="jump('/product')">
        {{bigName}}
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-current">
        {{name}}
      </div>
    </div>
    <div class="product">
      <div class="detail">
        <div class="left">
          <img class="wow animate__animated durationTime animate__fadeInUp" :style="{ width: imageWidth + 'rem' }" :src="require(`@/assets/${productsDetail.bigImg}`)">
          <div style="text-align: center">
            <img style="height: 0.4rem;margin-right: 0.1rem" v-for="item in imgs" :src="require(`@/assets/${item}`)">
          </div>
        </div>
        <div class="right">
          <div class="title">{{title}}</div>
          <div v-if="id==3">
            <div class="types">
              <div class="type">PSE型号:</div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                <div v-for="(item,index) in top2(productsDetail.list)"  @click="handleRuleChange(index)"  :class="[currentRule==='currentRule-'+index?'rule rule-check':'rule']">
                  <img class="pic" :src="require(`@/assets/${item.imgs[0].src}`)">
                  <div class="desc">
                    {{item.type}}
                  </div>
                </div>
              </div>
            </div>
            <div class="types">
              <div class="type">其他型号:</div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                <div v-for="(item,index) in top2V(productsDetail.list)"  @click="handleRuleChange(index+2)"  :class="[currentRule==='currentRule-'+(index+2)?'rule rule-check':'rule']">
                  <img class="pic" :src="require(`@/assets/${item.imgs[0].src}`)">
                  <div class="desc">
                    {{item.type}}
                  </div>
                </div>
              </div>
              <div class="type" style="margin-top: 0.4rem;margin-bottom: 0.1rem">产品特性:</div>
              <div class="spec" v-for="item in spe">
                <span class="circle"></span>
                <div class="desc">{{item}}</div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="types">
              <div class="type">型号:</div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                <div v-for="(item,index) in productsDetail.list"  @click="handleRuleChange(index)"  :class="[currentRule==='currentRule-'+index?'rule rule-check':'rule']">
                  <img class="pic" :src="require(`@/assets/${item.imgs[0].src}`)">
                  <div class="desc">
                    {{item.type}}
                  </div>
                </div>
              </div>
              <div class="type" style="margin-top: 0.4rem;margin-bottom: 0.1rem">产品特性:</div>
              <div class="spec" v-for="item in spe">
                <span class="circle"></span>
                <div class="desc">{{item}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div v-if="current.extra=='PSE'" class="pse">
        <div class="pse1" style=" padding: 1rem 0 0.8rem 0;margin-left: -2.18rem;margin-right: -2.18rem;
      background: #F6F8F9;display: flex;flex-direction: column;justify-content: center;align-items: center">
          <div style="font-weight: 600;font-size: 0.32rem;color: #3B5377;" class="title wow animate__animated durationTime animate__fadeInUp">PSE面板AP</div>
          <div style="font-weight: 600;margin: 0.2rem 0 0.6rem;
font-size: 0.2rem;
color: #999999;" class="secondTitle wow animate__animated durationTime animate__fadeInUp">场景创新，发明专利，一带一级联供电，成本降低一半</div>

          <div class="pseImg">
            <img class="gif" style="width: 8.54rem;height: 4.8rem" src="../../assets/image/product/pse.gif">
            <img class="gifImg" style="width: 8.54rem;height: 4.8rem" src="../../assets/image/product/pseImg.png">
          </div>

        </div>
        <div class="pse2" style="">
          <div class="title wow animate__animated durationTime animate__fadeInUp" style="">核心优势</div>
          <div class="con">
            <div class="item">
              <img src="../../assets/image/product/pse1.png">
              <div class="t wow animate__animated durationTime animate__fadeInUp">场景化创新与专利技术</div>
              <div class="desc wow animate__animated durationTime animate__fadeInUp">PSE面板AP产品特别为校园和工厂宿舍、酒店客房等多隔断场景设计，通过创新网络布线和设备部署，提升了网络覆盖效果，满足了集体宿舍中对高效、稳定网络的需求，彰显了方案的独特性和创新性。</div>
            </div>
            <div class="item">
              <img src="../../assets/image/product/pse2.png">
              <div class="t wow animate__animated durationTime animate__fadeInUp">一带一级联</div>
              <div class="desc wow animate__animated durationTime animate__fadeInUp">传统集体宿舍网络架构需要每个AP独立连接到交换机，网联创新方案允许一个PSE AP下联一台AP，减少布线复杂度，简化安装流程，实现了AP的一带一级联功能,使网络部署更高效便捷。</div>
            </div>
            <div class="item">
              <img src="../../assets/image/product/pse3.png">
              <div class="t wow animate__animated durationTime animate__fadeInUp">成本降低50%</div>
              <div class="desc wow animate__animated durationTime animate__fadeInUp">在项目集成中，技术方案显著减少了网线用量，降低了施工复杂度和工时成本，同时仅需一半的POE交换机端口数即可实现同样的网络覆盖，大幅节省了硬件投入和维护费用，建网成本降低50%。</div>
            </div>
          </div>
        </div>
      </div>

      <div style="font-size: 0.32rem;color: #3B5377;text-align: center;margin-top: 1rem;font-weight: 600;">技术规格</div>
      <div class="params">
        <div class="row" v-for="(row, rowIndex) in params" :key="rowIndex">
          <div  v-for="(item, itemIndex) in row" :key="itemIndex" :class="{'even-cell item': (rowIndex % 2 === 0 && itemIndex % 2 === 0) || (rowIndex % 2 !== 0 && itemIndex % 2 !== 0), 'odd-cell item': (rowIndex % 2 === 0 && itemIndex % 2 !== 0) || (rowIndex % 2 !== 0 && itemIndex % 2 === 0)}">
            <span style="    line-height: 0.3rem;" v-html="formatTextWithSemicolon(item)"></span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import productData from "./productsData.js";
import {WOW} from "wowjs";

export default {
  name: "partnerDetail",
  mounted() {
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true ,//异步加载的内容是否有效
    });
    wow.init();
  },
  data() {
    return {
      productsDetail: null,
      imageWidth:'',
      imgs:[],
      params:'',
      bigImg:'',
      title:'',
      currentRule:'currentRule-0',
      id:null,
      spe:[],
      bigName:'',
      name:'',
      current:null
    };
  },
  //为啥这里进来不是每次执行，在另外一个界面又是每次执行呢？
  // y:路由配置里面，不是每一项都要配置keepAlive:true的，默认不用去配置，当组件需要被缓存时再去配置
  created() {
    this.id=this.$route.query.id === undefined ? "1" : this.$route.query.id;
    this.handleData(0);
  },
  watch: {
    "$route.query.id": function(newVal) {
      this.id=newVal;
      this.handleData(0);
    }
  },
  computed: {
    formatTextWithSemicolon() {
      return (text) => {
        return text.replace(/;/g, '<br>');
      };
    }
  },
  methods: {
    top2(list){
      let copyData=[... list];
      console.log(copyData);
      return copyData.slice(0, 2)
    },
    top2V(list){
      let copyData=[... list];
      return copyData.slice(2)
    },
    handleRuleChange(index){
      this.currentRule="currentRule-"+index;
      this.handleData(index);
    },
    handleData(index) {
      this.productsDetail=null;
      this.imageWidth='';
      this.imgs=[];
      this.params='';
      this.bigImg='';
      this.title='';
      this.spe=[];
      this.current=null;
      const size = 4;
      this.productsDetail = productData.filter(v => this.id == v.id)[0].detail;
      this.bigName=productData.filter(v => this.id == v.id)[0].name;
      let d=this.productsDetail.list[index];
      this.current=d;
      this.name=d.type;
      this.productsDetail.bigImg=d.imgs[0].src;
      this.imageWidth=d.imgs[0].w;
      //todo 这里要做图片切换
      // if(d.imgs.length>1){
      //   for (let i=0;i<d.imgs.length;i++){
      //     this.imgs.push(d.imgs[i].src);
      //   }
      // }
      this.params=d.params.reduce((acc, _, index) => index % size ? acc : [...acc, d.params.slice(index, index + size)], []);
      this.title=d.name+"，"+d.type;
      this.spe=d.spec;
    },
    handleDetail(id) {
      this.handleData(id);
    },
    goBack() {
      this.$router.go(-1);
    },
    jump(r) {
      this.$router.push({ path: r });
    },
  }
};
</script>
<style scoped lang="scss">

</style>
<style  scoped lang="scss">
.product{
   .detail{
     display: flex;
     align-items: center;


     .left{
       width: 50%;
       text-align: center;
     }
     .right{
       width: 50%;
       .title{
         font-weight: 600;
         font-size: 0.34rem;
         color: #333333;
         white-space: nowrap;
       }
       .types{
         margin-top: 0.4rem;
         padding-left: .2rem;
         .spec{
           position: relative; /* 相对定位 */
           padding-left: 0.2rem; /* 圆点的宽度加上间距 */
           margin-bottom: 0.1rem;
           .circle {
             position: absolute; /* 绝对定位 */
             left: 0; /* 相对于 .list-item 左侧对齐 */
             //transform: translateY(-50%); /* 垂直居中 */
             width: 0.1rem; /* 圆点的直径 */
             height: 0.1rem;
             background-color: black; /* 圆点的颜色 */
             border-radius: 50%; /* 将正方形变成圆形 */
             margin-right: 0.1rem; /* 圆点和文字之间的间距 */
             margin-top: 0.04rem;
           }
           .desc{
             font-size: 0.14rem;
           }
         }
         .type{
           font-size: 0.14rem;
         }
         .rule{
           cursor: pointer;
           height: 0.8rem;
           //width: 3.68rem;
           border: 1px solid #DBDBDB;
           display: flex;
           padding:0.16rem 0.6rem 0.16rem 0.32rem;
           align-items: center;
           width: calc((100% - 0.2rem) / 2);
           margin-top: 0.2rem;
           //justify-content: space-between;
           .desc{
             font-weight: 600;
             font-size: 0.16rem;
             color: #333333;
             white-space: nowrap;
           }
           .pic{
             height: 100%;
             margin-right: 0.3rem;
             max-width: 45%;
           }
         }
         .rule-check{
           border: 1px solid #FEF100;
         }
       }
     }
   }
  .params{
    margin-top: 0.4rem;
  }
  .row {
    display: flex;
    font-size: 0.18rem;
  }

  /* 设置基数行的样式*/
  .row:nth-child(odd) {
    background-color: #E6E6E6;
    .even-cell {

      width: 1.95rem;
      padding: 0.3rem 0 0.3rem 0.3rem;
    }
    .odd-cell{
      width: 5.85rem;
      padding: 0.3rem 0.8rem 0.3rem 0.5rem;
    }
    .item{
      border-right: 1px solid #FFFFFF;
      display: flex;
      align-items: center;
    }
    .item:last-child{
      border: none;
    }
  }
  /* 设置偶数行的样式*/
  .row:nth-child(even) {
    background-color: #F7F7F7;
    .even-cell {
      width: 5.85rem;
      padding: 0.3rem 0.8rem 0.3rem 0.5rem;

    }
    .odd-cell{
      width: 1.95rem;
      padding: 0.3rem 0 0.3rem 0.3rem;
    }
    .item{
      border-right: 1px solid #F7F7F7;
      display: flex;
      align-items: center;
    }
    .item:last-child{
      border: none;
    }
  }
  padding: 0.29rem 2.18rem 2.21rem 2.18rem;
}
.news-nav {
  padding: 0.29rem 0 0.29rem 2.18rem;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.news-prev > img,
.news-next > img,
.news-nav > img {
  width: 0.06rem;
  height: 0.12rem;
}
.news-nav > img {
  margin: 0 0.2rem;
}
.news-prev > img {
  margin-right: 0.1rem;
}
.news-next > img {
  margin-left: 0.1rem;
}
.news-nav-pre {
  font-size: 0.16rem;
  font-weight: 400;
  color: #999999;
}
.news-nav-current {
  height: 0.22rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
.pse2{
  //padding:1rem 2.18rem 0 2.18rem;
  padding-top: 1rem;
  .title{
    font-weight: 600;font-size:0.32rem;color: #3B5377;text-align: center
  }
  .con{
    margin-top: 0.8rem;
    display: flex;
    justify-content: space-between;
    .item{
      background: url('../../assets/image/product/pseBg.png') center no-repeat;
      //background-size: cover;
      background-size: contain;
      width: 4.78rem;
      height: 5.41rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        width: 1.38rem;
        margin-top: 0.8rem;
      }
      .t{
        font-weight: 500;
        font-size: 0.3rem;
        color: #347DEA;
        margin: 0.4rem 0;
      }
      .desc{
        font-weight: 400;
        font-size: 0.16rem;
        color: #000000;
        width: 3.82rem;
        line-height: 0.3rem;
      }
    }
  }
}
.pse1{
  //height: 8.53rem;
}
.pseImg{
  .gif{
    display: none;
    //display: block;
  }
  .gifImg{
    //display: none;

  }
}
.pse1:hover{
  .gif{
    display: block;
  }
  .gifImg{
    display: none;

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/product/productDetail.vue